import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { DatePicker } from '@atlaskit/datetime-picker';
import EditorSearchIcon from '@atlaskit/icon/glyph/editor/search';
import Select from '@atlaskit/select';
import Textfield from '@atlaskit/textfield';
import { N500 } from '@atlaskit/theme/colors';
import { DateUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { Action, Author, BaseResultsOn, DateRange, EvaluationsBy, FeedbackBy, FeedbackReasons, FeedbackSource, Hosting, LicenseStatus, LicenseType, Reports, SaleChannel, SalesBy, SaleType, TypeOfLicensesData } from "./filtersOptions";

const SourceTooltipContainer = _styled("div", {
  target: "eykwwqh0",
  label: "SourceTooltipContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "48w1z6",
  styles: "padding:10px;ul{margin-top:10px;padding-left:25px;}"
} : {
  name: "48w1z6",
  styles: "padding:10px;ul{margin-top:10px;padding-left:25px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

const SourceFilterTooltip = () => {
  return /*#__PURE__*/React.createElement(SourceTooltipContainer, null, /*#__PURE__*/React.createElement("div", null, "Source refers to the page customer feedback was collected from."), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "New Cloud reasons were introduced on Sep 15, 2021, and are now standardised across all feedback pages for Cloud apps."), /*#__PURE__*/React.createElement("li", null, "Manage apps now refers to reasons collected from the manage apps page for Data Center and Server apps."), /*#__PURE__*/React.createElement("li", null, "Admin hub now refers to reasons collected from the admin hub page for Data Center and Server apps."), /*#__PURE__*/React.createElement("li", null, "Before Sep 15, 2021, Manage apps and Admin hub are valid sources for all Cloud, Data Center, and Server apps"))));
};

const dateRangeFilter = {
  label: 'Date range',
  data: DateRange,
  queryParam: 'period',
  component: Select
};
const allFilters = {
  sales: [dateRangeFilter, {
    label: 'Sales by',
    data: SalesBy,
    queryParam: 'metric',
    component: Select
  }],
  evaluations: [dateRangeFilter, {
    label: 'Evaluations by',
    data: EvaluationsBy,
    queryParam: 'metric',
    component: Select
  }],
  feedback: [dateRangeFilter, {
    label: 'Feedback by',
    data: FeedbackBy,
    queryParam: 'metric',
    component: Select
  }, {
    label: 'Source',
    data: FeedbackSource,
    queryParam: 'source',
    component: Select,
    tooltip: SourceFilterTooltip
  }],
  conversions: [dateRangeFilter],
  renewals: [dateRangeFilter],
  churn: [dateRangeFilter],
  transactions: [{
    label: 'Apps',
    queryParam: 'addon',
    component: Select
  }, dateRangeFilter, {
    label: 'Hosting',
    data: Hosting,
    queryParam: 'hosting',
    component: Select
  }, {
    label: 'Sale type',
    data: SaleType,
    queryParam: 'saleType',
    component: Select
  }, {
    label: 'Sale channel',
    data: SaleChannel,
    queryParam: 'partnerType',
    component: Select
  }, {
    label: 'Search',
    queryParam: 'text',
    component: Textfield,
    width: '230px',
    attributes: {
      elemBeforeInput: /*#__PURE__*/React.createElement(EditorSearchIcon, {
        primaryColor: N500
      })
    }
  }],
  licenses: [{
    label: 'Apps',
    queryParam: 'addon',
    component: Select
  }, dateRangeFilter, {
    label: 'Base results on',
    data: BaseResultsOn,
    queryParam: 'dateType',
    component: Select
  }, {
    label: 'Hosting',
    data: Hosting,
    queryParam: 'hosting',
    component: Select
  }, {
    label: 'License status',
    data: LicenseStatus,
    queryParam: 'status',
    component: Select
  }, {
    label: 'Sale Channel',
    data: SaleChannel,
    queryParam: 'partnerType',
    component: Select
  }, {
    label: 'License Type',
    data: LicenseType,
    queryParam: 'licenseType',
    component: Select
  }, {
    label: 'Type of data',
    data: TypeOfLicensesData,
    queryParam: 'withDataInsights',
    component: Select,
    tooltip: 'You need to download additional insights as a CSV to view the data. Enter a date range up to 90 days'
  }, {
    label: 'Search',
    queryParam: 'text',
    component: Textfield,
    width: '230px',
    attributes: {
      elemBeforeInput: /*#__PURE__*/React.createElement(EditorSearchIcon, {
        primaryColor: N500
      })
    }
  }],
  'feedback-details': [{
    label: 'Apps',
    queryParam: 'addon',
    component: Select
  }, dateRangeFilter, {
    label: 'Hosting',
    data: Hosting,
    queryParam: 'hosting',
    component: Select
  }, {
    label: 'Action',
    data: Action,
    queryParam: 'type',
    component: Select
  }, {
    label: 'Author',
    data: Author,
    queryParam: 'author',
    component: Select
  }, {
    label: 'Reason',
    data: FeedbackReasons,
    queryParam: 'reason',
    component: Select
  }, {
    label: 'Search',
    queryParam: 'text',
    component: Textfield,
    width: '230px',
    attributes: {
      elemBeforeInput: /*#__PURE__*/React.createElement(EditorSearchIcon, {
        primaryColor: N500
      })
    }
  }]
};
const filtersToBeShownAlways = new Set(['feedback-details', 'feedback', '']);

const getReportsNameFilter = (reportName, canViewSalesReport) => ({
  label: 'Reports',
  data: canViewSalesReport ? Reports : Reports.filter(report => filtersToBeShownAlways.has(report.value)),
  appendUrl: true,
  component: Select,
  value: Reports.find(report => report.value === reportName)
});

const disableFutureDate = date => DateUtils.isFutureDate(new Date("".concat(date, ", 0:0:0")));

const getCustomDateFilter = () => [{
  label: 'Start date',
  queryParam: 'startDate',
  component: DatePicker,
  attributes: {
    disabledDateFilter: disableFutureDate,
    placeholder: 'Start date'
  }
}, {
  label: 'End date',
  queryParam: 'endDate',
  component: DatePicker,
  attributes: {
    disabledDateFilter: disableFutureDate,
    placeholder: 'End date'
  }
}]; // This function includes (Start & End) Date filter when user select custom date


const includeCustomDateFilters = filters => {
  const dateRangeIndex = filters.findIndex(filter => filter.queryParam === 'period');
  return [...filters.slice(0, dateRangeIndex + 1), ...getCustomDateFilter(), ...filters.slice(dateRangeIndex + 1)];
};
/*
 * This function is used to removes Feedback Source filter when feedback report is by type
 */


const excludeFeedbackSourceFilter = filters => {
  return filters.filter(filterItem => filterItem.label !== 'Source');
}; // Main function which will return all Filters for a given Report


export const getFilters = (reportingApps, reportName, queryParams, canViewSalesReport) => {
  let filters = [getReportsNameFilter(reportName, canViewSalesReport), ...(allFilters[reportName] || [])]; // Assign Apps response to the Apps filter

  const appsFilter = filters.find(filter => filter.label === 'Apps');

  if (appsFilter) {
    appsFilter.data = [{
      label: 'All apps',
      value: undefined
    }, ...reportingApps];
  }

  if (queryParams.period === 'custom') {
    filters = includeCustomDateFilters(filters);
  }

  if (reportName === 'feedback' && queryParams.metric === 'type') {
    filters = excludeFeedbackSourceFilter(filters);
  }

  return filters;
};